import React from 'react';
import { Zap } from 'lucide-react';

/**
 * BetaBanner - A prominent floating banner displayed at the top of every page
 * during the Early Access Beta period.
 */
function BetaBanner() {
  return (
    <div className="bg-orange-500 py-2.5 px-4 shadow-lg sticky top-0 z-[100]">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-4">
        <div className="flex items-center gap-2">
          <Zap className="w-5 h-5 sm:w-6 sm:h-6 text-white animate-bounce" />
          <span className="text-white font-extrabold text-base sm:text-lg tracking-wide">BETA ACCESS</span>
        </div>
        <span className="text-white/90 text-sm hidden sm:inline">You're among the first to try DrawReady!</span>
      </div>
    </div>
  );
}

export default BetaBanner;
